import { render, staticRenderFns } from "./OpenIDRes.vue?vue&type=template&id=841e3f4e&"
import script from "./OpenIDRes.vue?vue&type=script&lang=js&"
export * from "./OpenIDRes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports